
import {
  INIT_BRAND_INFO,
  REQUEST_BRAND_START,
  REQUEST_BRAND_SUCCESS,
  REQUEST_BRAND_FAIL,
} from '../actions/brand';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_BRAND_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_BRAND_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_BRAND_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_BRAND_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
